"use client";

import { Text } from "@pamperedchef/design-system";

import { ListingPageLink } from "../ListingPageLink";

import * as styles from "./LoadMore.module.scss";

export interface LoadMoreProps {
	/** The position of the last product shown. */
	loaded: number;
	/** The position of the first product shown, past 1 on a deep url. */
	first?: number;
	total: number;
	/** The url of the next set, so the link works and is crawled without script. */
	href: string;
	isLoading?: boolean;
	/** Appends the next set in place; without it the link loads the next url. */
	onLoadMore?: () => void;
	label?: string;
}

function countLabel(first: number, loaded: number, total: number): string {
	const shown = first > 1 ? `${first}–${loaded}` : `${loaded}`;
	return `Showing ${shown} of ${total} ${total === 1 ? "result" : "results"}`;
}

export function LoadMore({
	loaded,
	first = 1,
	total,
	href,
	isLoading = false,
	onLoadMore,
	label = "Load More"
}: LoadMoreProps): JSX.Element {
	const hasMore = loaded < total;

	return (
		<div className={styles["load-more"]} data-component="LoadMore">
			<Text
				tag="p"
				className={styles["load-more__count"]}
				aria-live="polite"
			>
				{countLabel(first, loaded, total)}
			</Text>
			{hasMore ? (
				<ListingPageLink
					href={href}
					rel="next"
					label={label}
					isLoading={isLoading}
					onNavigate={onLoadMore}
				/>
			) : null}
		</div>
	);
}
